var map = {
	"./Administrative_Fees_Levies_eng.svg": 63065,
	"./Administrative_Fees_Levies_fre.svg": 90632,
	"./Administrative_Fees_Levies_swa.svg": 85436,
	"./Administrative_Issues_eng.svg": 78519,
	"./Administrative_Issues_fre.svg": 52852,
	"./Administrative_Issues_swa.svg": 52777,
	"./Corruption_eng.svg": 1199,
	"./Corruption_fre.svg": 81767,
	"./Corruption_swa.svg": 84645,
	"./EAC-dashboard.png": 91794,
	"./EAC_logo_transp.png": 18826,
	"./Immigration_Requirements_eng.svg": 6246,
	"./Immigration_Requirements_fre.svg": 38859,
	"./Immigration_Requirements_swa.svg": 11217,
	"./Import_Ban_eng.svg": 95933,
	"./Import_Ban_fre.svg": 78655,
	"./Import_Ban_swa.svg": 31268,
	"./Import_Licensing_eng.svg": 37794,
	"./Import_Licensing_fre.svg": 98092,
	"./Import_Licensing_swa.svg": 90647,
	"./Lack_of_Clarity_on_Border_Procedures_eng.svg": 758,
	"./Lack_of_Clarity_on_Border_Procedures_fre.svg": 7109,
	"./Lack_of_Clarity_on_Border_Procedures_swa.svg": 67746,
	"./Lengthy_Costly_Customs_Procedures_eng.svg": 12449,
	"./Lengthy_Costly_Customs_Procedures_fre.svg": 89153,
	"./Lengthy_Costly_Customs_Procedures_swa.svg": 11259,
	"./Other_eng.svg": 27582,
	"./Other_fre.svg": 39070,
	"./Other_swa.svg": 81090,
	"./Poor_Testing_Inspection_Facilities_eng.svg": 77944,
	"./Poor_Testing_Inspection_Facilities_fre.svg": 75328,
	"./Poor_Testing_Inspection_Facilities_swa.svg": 83588,
	"./Road_Border_Infrastructure_eng.svg": 76082,
	"./Road_Border_Infrastructure_fre.svg": 95555,
	"./Road_Border_Infrastructure_swa.svg": 2514,
	"./Rules_of_Origin_Issues_eng.svg": 64571,
	"./Rules_of_Origin_Issues_fre.svg": 5664,
	"./Rules_of_Origin_Issues_swa.svg": 77257,
	"./eac_t.png": 32023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;